import { useEffect, useRef } from "react";
import type { FC } from "react";

/** The pointer as a plus with hairlines across the whole viewport. Only where there is a mouse. */
export const Crosshair: FC = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    const move = (e: PointerEvent) => {
      el.style.setProperty("--cx", `${e.clientX}px`);
      el.style.setProperty("--cy", `${e.clientY}px`);
      el.dataset.on = "";
      // Over something you can press the plus turns, since the hand cursor is gone.
      if (e.target instanceof Element && e.target.closest("a, button, [role=button]")) el.dataset.hot = "";
      else delete el.dataset.hot;
    };
    const leave = () => {
      delete el.dataset.on;
    };
    window.addEventListener("pointermove", move, { passive: true });
    document.documentElement.addEventListener("pointerleave", leave);
    return () => {
      window.removeEventListener("pointermove", move);
      document.documentElement.removeEventListener("pointerleave", leave);
    };
  }, []);

  return (
    <div ref={ref} className="sd-cross" aria-hidden>
      <i />
      <i />
      <b />
    </div>
  );
};
